import { type ReadonlySignal } from '@preact/signals'

import { Typography, Button, Modal } from 'components/UI'

interface Props {
	bannerErrorMessage?: string
	collaboratorUsername: ReadonlySignal<string>
	isModalOpen: boolean
	isRemoveCollaboratorButtonDisabled: boolean
	isRemoveCollaboratorButtonLoading: boolean
	onCloseRemoveCollaboratorModal: () => void
	projectName: string
	removeCollaborator: () => void
}

const RemoveCollaboratorModal = ({
	bannerErrorMessage,
	collaboratorUsername,
	isModalOpen,
	isRemoveCollaboratorButtonDisabled,
	isRemoveCollaboratorButtonLoading,
	onCloseRemoveCollaboratorModal,
	projectName,
	removeCollaborator
}: Props) => (
	<Modal
		bannerErrorMessage={bannerErrorMessage}
		className='border border-black-600 p-10 text-center'
		isOpen={isModalOpen}
		onCloseModal={onCloseRemoveCollaboratorModal}
	>
		<Typography
			class='mt-6'
			color='text-black-100'
			text='Remove Collaborator'
			variant='h1'
		/>

		<Typography
			class='mt-4'
			color='text-black-200'
			text={`Are you sure you want to remove the ${collaboratorUsername} from the ${projectName} project?`}
			variant='text2'
		/>

		<div class='mt-10 flex justify-center'>
			<Button
				disabled={isRemoveCollaboratorButtonDisabled}
				isLoading={isRemoveCollaboratorButtonLoading}
				onClick={removeCollaborator}
				text='Remove Collaborator'
				variant='error'
			/>
		</div>
	</Modal>
)

export { RemoveCollaboratorModal }
